var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("title"),_vm._v(" "),_vm._t("default",null,{"showpopin":_vm.showPopin})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }